import React from 'react';
import {AppGridLayout ,AppTable,AppTableSearch,AppSearchItem,AppButton,AppRow,AppGridBar} from 'qcc';
import {AppAction} from 'qcc';
import {default as EditForm} from './EditForm';
import {default as RoleUserIndex} from './RoleUserIndex';
import api,{AppRole} from 'api';

export default class extends React.Component {
    
    addRole = () =>{
        let role = {is_admin:1,name:''}
        AppAction.openDialog(<EditForm mode={1} formData={role} afterSave={this.afterSave}/>,{title:'新增角色'})
    }

    editRole = (role?:any) =>{
        let mode = role.id === 1 ? 3 :2;
        AppAction.openDialog(<EditForm mode={mode} formData={role} id={role.id} afterSave={this.afterSave}/>,{title:'编辑角色'})
    }

    deleteRole = async (role?:AppRole) =>{
        if(role.id === 1){
            AppAction.alert('改记录为系统数据，不允许删除！')
            return false;
        }
           
        if(await AppAction.deleteConfirm('您确定要删除该记录吗？')){
           let res = await api.role.deleteRole(role);
           AppAction.successMsg('删除成功！');
           this.refGrid.current && this.refGrid.current.state.refTable.fetch();
           return true;
        }
        return false;
    }

    openRoleUser = (role?:AppRole) =>{
        let title = `角色授权(${role.name})`
        let formCompent = <RoleUserIndex roleId={role.id}/>
        AppAction.openDrawer(formCompent,{title,width:920})
    }

    afterSave = () =>{
        this.refGrid.current && this.refGrid.current.state.refTable.fetch();
        AppAction.closeDialog();
    }

    refGrid = React.createRef<AppGridLayout>();


	render() {
		return (
        <AppGridLayout>
            <AppGridLayout.SearchArea>
                <AppTableSearch>
                    <AppTableSearch.Common>
                        <AppSearchItem.SearchInput placeholder='请录入姓名' keyName='common' field='name'/>
                    </AppTableSearch.Common>
                </AppTableSearch>
            </AppGridLayout.SearchArea>
            <AppGridLayout.MenuArea>
                <AppGridBar>
                    <AppGridBar.Right>
                        <AppButton label='新增' actionCode='00010101'  type='primary' action={this.addRole}/>
                    </AppGridBar.Right>
                </AppGridBar>
            </AppGridLayout.MenuArea>
            <AppGridLayout.GridArea>
                <AppTable paging sqlId='sql.role.gridAdmin'>
                <AppTable.ColIndex />
                    <AppTable.Col title='名称' field='name' />
                    <AppTable.ColAction render={(data:AppRole,dataIndex:number)=>{
                        return (<AppRow itemSplit={10} style={{float:'right'}}>
                         <AppButton type='link' label='用户分配' actionCode='00010105' action={()=>this.openRoleUser(data)} />
                            <AppButton type='link' label='编辑' actionCode='00010102'  action={()=>this.editRole(data)} />
                            <AppButton type='link' label='删除' actionCode='00010103'  auditAction={()=>this.deleteRole(data)} />
                        </AppRow>)
                    }}/>
                </AppTable>
            </AppGridLayout.GridArea>
        </AppGridLayout>)
	}
}


// WEBPACK FOOTER //
// ./src/page/application/role/IndexAdminGrid.tsx